import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination, Scrollbar} from 'swiper/modules';
import {getOptionsFromJsonString} from "../../../default/global/js/utilities/options";


export function initItemlistSlider(query = document.querySelectorAll('.itemboxList.swiper'), options = {}) {
    let defaultOptions = {
        breakpointItems: {
            xs: 1.1,
            sm: 2.1,
            md: 3.1,
            lg: 3.1,
            xlg: 4.1
        }
    };

    defaultOptions = {...defaultOptions, ...options};

    Swiper.use([Autoplay, Navigation, Pagination, Scrollbar]);

    for (let itemlist of query) {

        let options = getOptionsFromJsonString(itemlist.getAttribute('data-options'), defaultOptions);
        let forceLoop = false;

        options.breakpointItems.xs = 1.1;
        options.breakpointItems.sm = 2.1;
        options.breakpointItems.md = 3.1;
        options.breakpointItems.lg = 3.1;
        options.breakpointItems.xlg = 4.1;

        if (itemlist.closest(".col-md-8")) {
            options.breakpointItems.md = 3;
            options.breakpointItems.lg = 3;
            options.breakpointItems.xlg = 3;
        }

        const parentQueryElement = itemlist.parentElement;

        if (parentQueryElement && parentQueryElement.classList.contains("row") && parentQueryElement.querySelector(".contentBox--textinbox")) {
            options.breakpointItems.xs = 1.1;
            options.breakpointItems.sm = 2.1;
            options.breakpointItems.md = 2.1;
            options.breakpointItems.lg = 2.1;
            options.breakpointItems.xlg = 2.2;
        }

        if (parentQueryElement && parentQueryElement.classList.contains("tabArticle")) {
            const wrapWidth = parentQueryElement.offsetWidth;
            const count = wrapWidth / (425 + 15);
            options.breakpointItems.xs = 1;
            options.breakpointItems.sm = 2;
            options.breakpointItems.md = count;
            options.breakpointItems.lg = count;
            options.breakpointItems.xlg = count;
            forceLoop = true;
        }

        if (parentQueryElement && parentQueryElement.classList.contains("athletesArticle")) {
            options.breakpointItems.xs = 1;
            options.breakpointItems.sm = 1;
            options.breakpointItems.md = 1;
            options.breakpointItems.lg = 1;
            options.breakpointItems.xlg = 1;
        }

        const bp = {
            xs: options.breakpointItems.xs,
            sm: options.breakpointItems.sm,
            md: options.breakpointItems.md,
            lg: options.breakpointItems.lg,
            xlg: options.breakpointItems.xlg,
        };

        const maxSpv = Math.max(bp.xs, bp.sm, bp.md, bp.lg, bp.xlg);
        const wrapper = itemlist.querySelector('.swiper-wrapper');
        const originalHTML = wrapper.innerHTML;
        const originalCount = wrapper.querySelectorAll(':scope > *').length;
        const navNextEl = itemlist.querySelector('.swiper-button-next');
        const navPrevEl = itemlist.querySelector('.swiper-button-prev');

        let swiperInstance = null;
        let activeLoopState = null;

        function getSpvForWidth(w) {
            return w >= 1540 ? bp.xlg : w >= 1250 ? bp.lg : w >= 1024 ? bp.md : w >= 768 ? bp.sm : bp.xs;
        }

        function buildSlider() {
            const loopEnabled = forceLoop || originalCount > getSpvForWidth(window.outerWidth);

            if (swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null;
            }

            // Reset to original slides, removing any previously added clones
            wrapper.innerHTML = originalHTML;

            if (loopEnabled) {
                const originalSlides = Array.from(wrapper.querySelectorAll(':scope > *'));
                const minSlides = Math.ceil(maxSpv) * 2 + 1;
                let idx = 0;
                while (wrapper.children.length < minSlides) {
                    wrapper.appendChild(originalSlides[idx % originalCount].cloneNode(true));
                    idx++;
                }
            }

            activeLoopState = loopEnabled;
            itemlist.classList.toggle('slider--loop', loopEnabled);

            swiperInstance = new Swiper(itemlist, {
                loop: loopEnabled,
                slidesPerGroup: 1,
                roundLengths: true,
                speed: 300,
                spaceBetween: 15,
                watchSlidesProgress: true,
                autoHeight: false,
                scrollbar: {
                    el: '.itemListScrollbar',
                    hide: false
                },
                navigation: {
                    nextEl: navNextEl,
                    prevEl: navPrevEl,
                },
                breakpoints: {
                    0:    {slidesPerView: bp.xs,  slidesPerGroup: 1},
                    768:  {slidesPerView: bp.sm,  slidesPerGroup: 1},
                    1024: {slidesPerView: bp.md,  slidesPerGroup: 1},
                    1250: {slidesPerView: bp.lg,  slidesPerGroup: 1},
                    1540: {slidesPerView: bp.xlg, slidesPerGroup: 1},
                },
            });
        }

        buildSlider();

        // Reinit only when the loop state changes across a breakpoint
        let resizeTimer = null;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                const newLoopEnabled = forceLoop || originalCount > getSpvForWidth(window.outerWidth);
                if (newLoopEnabled !== activeLoopState) {
                    buildSlider();
                }
            }, 200);
        });
    }
}
